import { useState } from "react";

export default function Controls({ onAnalyze, loading }) {
    const [market, setMarket] = useState("DOW");
    const [period, setPeriod] = useState("1y");

    return (
        <div className="controls">
            <label>Market: </label>
            <select value={market} onChange={(e) => setMarket(e.target.value)}>
                <option value="DOW">Dow Jones</option>
                <option value="SP500">S&P 500</option>
                <option value="NASDAQ">NASDAQ</option>
            </select>

            <label style={{ marginLeft: "10px" }}>Lookback Period: </label>
            <select value={period} onChange={(e) => setPeriod(e.target.value)}>
                <option value="1mo">1 Month</option>
                <option value="3mo">3 Months</option>
                <option value="6mo">6 Months</option>
                <option value="1y">1 Year</option>
            </select>

            <button
                onClick={() => onAnalyze(market, period)}
                style={{ marginLeft: "10px" }}
                disabled={loading}
                className={loading ? "button loading" : "button"}
            >
                {loading ? "Loading..." : "Analyze"}
            </button>
        </div>
    );
}